import { getAuthAxiosBackend } from "@/helpers/axios"

class AdministrativeDataServices{

    get(id){
        return getAuthAxiosBackend().get('AdministrativeData/getAdministrativeData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('AdministrativeData/getAdministrativeDataByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('AdministrativeData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('AdministrativeData/addAdministrativeData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('AdministrativeData/updateAdministrativeData/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('AdministrativeData/softDeleteAdministrativeData/' + id.toString())
    }
}

export default new AdministrativeDataServices()